import React from "react";
import Service from "../Components/Service";
import SectionIntro from "../Components/SectionIntro";
import OutlinedButton from "../Components/OutlinedButton";

const Services: React.FC = () => {
  return(
    <div className="bg-primary pt-12 2xl:pt-20 pb-12">
      <SectionIntro eyebrow="Per lui" title="Benvenuto nel nostro laboratorio" titleColor="text-quaternary"/>
      <ul className="grid grid-cols-1 md:grid-cols-2 2xl:grid-cols-3 gap-x-10 max-w-[1200px] mx-auto px-8 pt-4 pb-6">
        <Service icon="bg-service-scissors" header="Zero Time Hair" headerTextColor={"quaternary"} text="Shampoo, taglio, panno rigenerante e styling"/>
        <Service icon="bg-service-scissors" header="MR Trewan Hair" headerTextColor={"quaternary"} text="Immergiti nei suoni della natura con il nostro esclusivo trattamento. Comodamente sdraiato con cuffie e massaggi in aromaterapia. Una pausa meritata"/>
        <Service icon="bg-service-scissors" header="L’Experience Hair" headerTextColor={"quaternary"} text="Fitoargilla con massaggio immersivo, shampoo, taglio, trattamento Seremony intenso con panni caldi profumati e fragranza Armonia"/>
        <Service icon="bg-service-razor" header="Zero Time Beard" headerTextColor={"quaternary"} text="Definizione o rasatura della barba panno caldo profumato fragranza Naturale"/>
        <Service icon="bg-service-razor" header="MR Trewan Beard" headerTextColor={"quaternary"} text="Regolazione o rasatura della barba triplo panno caldo profumato olio di mandorla addolcente fragranza Armonia"/>
        <Service icon="bg-service-razor" header="L’Experience Beard" headerTextColor={"quaternary"} text="Regolazione e rasatura della barba triplo panno caldo profumato trattamento purificante viso con fitoargilla massaggio immersivo olio di mandorla addolcente fragranza Armonia"/>
      </ul>
      <div className="p-12 flex items-center justify-center">
        <OutlinedButton href={"/Prezzario-Web.pdf"} downloadName={"Menu MR Trewan"} download={true} color="white">Scopri di più</OutlinedButton>
      </div>
    </div>
  )
};

export default Services;
